import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../../../../layout/theme-next/provider';

export default makeStyles<NextTheme>((theme) => ({
  container: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    height: 30,
    marginRight: theme.spacing(1.5),
  },
}));
